/*=========================================================================================
  File Name: moduleAuthActions.js
  Description: Auth Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import jwt from '../../http/requests/auth/jwt/index.js'
// import auth0 from "auth0-js";
import JwtDecode from 'jwt-decode'

import router from '@/router'

// 'loggedIn' is used in other parts of application. So, Don't forget to change there also
// authService.js
const localStorageKey = 'loggedIn'

export default {
  updateUsername({commit}, payload) {
    payload.user
      .updateProfile({
        displayName: payload.displayName
      })
      .then(() => {
        // If username update is success
        // update in localstorage
        const newUserData = Object.assign({}, payload.user.providerData[0])
        newUserData.displayName = payload.displayName
        commit('UPDATE_USER_INFO', newUserData, {root: true})

        // If reload is required to get fresh data after update
        // Reload current page
        if (payload.isReloadRequired) {
          router.push(router.currentRoute.query.to || '/')
        }
      })
      .catch(error => {
        payload.notify({
          time: 8800,
          title: 'Error',
          text: error.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      })
  },

  // JWT
  loginJWT({commit}, payload) {
    return new Promise((resolve, reject) => {
      jwt
        .login(payload.userDetails.email, payload.userDetails.password)
        .then(response => {
          // If response is 200 and there is data (jwt), then continue to homepage
          if (response.status == 200 && response.data) {
            // Set accessToken
            localStorage.setItem('accessToken', response.data)

            // set loggedIn to true
            localStorage.setItem(localStorageKey, true)

            // Set bearer token in axios (http library)
            commit('SET_BEARER', response.data)

            let decodedJWT = JwtDecode(response.data)

            let payload = {
              displayName: decodedJWT.username,
              email: '',
              photoURL: require('@/assets/images/user_avatar.png'),
              providerId: '',
              uid: decodedJWT.id
            }

            commit('UPDATE_USER_INFO', payload, {root: true})

            // Navigate User to homepage
            router.push(router.currentRoute.query.to || '/')

            resolve(response)
          } else {
            reject({message: 'Wrong Email or Password'})
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  registerUserJWT({commit}, payload) {
    const {
      displayName,
      email,
      password,
      confirmPassword
    } = payload.userDetails

    return new Promise((resolve, reject) => {
      // Check confirm password
      if (password !== confirmPassword) {
        reject({message: 'Password doesn\'t match. Please try again.'})
      }

      jwt
        .registerUser(displayName, email, password)
        .then(response => {
          // Redirect User
          router.push(router.currentRoute.query.to || '/')

          // Update data in localStorage
          localStorage.setItem('accessToken', response.data.accessToken)
          commit('UPDATE_USER_INFO', response.data.userData, {root: true})

          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  fetchAccessToken() {
    return new Promise(resolve => {
      jwt.refreshToken().then(response => {
        resolve(response)
      })
    })
  }
}
